import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withKeys as _withKeys, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17620a3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "today-is-holiday"
}
const _hoisted_2 = {
  key: 1,
  class: "today-is-saturday"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  opacity: "0.8",
  width: "31",
  height: "55.8",
  fill: "url(#pattern0_2020_787)"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("pattern", {
    id: "pattern0_2020_787",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, [
    /*#__PURE__*/_createElementVNode("use", {
      "xlink:href": "#image0_2020_787",
      transform: "matrix(0.0111111 0 0 0.00617284 0 0.222222)"
    })
  ]),
  /*#__PURE__*/_createElementVNode("image", {
    id: "image0_2020_787",
    width: "90",
    height: "90",
    "xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACJUlEQVR4nO2cTY4TQQyFawUcASbdfsbVo0g5GzPsCCfkZ8VwFJTZsAoqVkMkFr3osl39PsmbyOqovjhu6S2qFEIIIYQQQgghhBBSALyxWT9WwXeDPlfodcQy6LMJvpno47Isr7v+9Mthmargp7eE2rsET+3s3SZ5l5LxQnaPyf67LrwPC2/Z+rC56LaT3Q8K3zLRr5uLNuDifdDqLRq4bC76f19eBqV6nZeilaK3gBPdCYruBEV3gqI7QdGdoOhOUHQnKLoTFL1X0XurQtFK0TXAJHKi4S+PqwP+YrmjQdHuU1c50eouiqsD/hKH2tEm+G2in47zfNfKRM/tsyz9iUTr+fbZ7bMs/SWLaBF5d/tsAG+z9Jcsoo/zfHf77PtpOmTpL6lXB/A5S3/JIxrt5XNe+bIK059GdE1eFA2KvnpPISca/uK4OuAvlTsaOxQdLYuwUbOOaFmEjZp1RMsiZNSsI1oWcRw164iWRdioWUe0LMKYdegQ5TbRe6tC0UrRNcAkcqLhL4+rA/5iw+zoaFmErexPJDpWFmEr+9OIjpZFyMr+NKKjZRHHlf1pREfLImxlfyLRsbIIW9mfRvTeqlC0UnQNMIlpJprXsWnb/7+2Xx28YPDa54JB0Ufvv231Lnn/YXPR7QLUdhGq+2HhUyb643Q6vdpc9ItrjZ/2KPl+mg5dJP872frQ9tXIL0gDLib6pa2LbpNMCCGEEEIIIYQQUmLzB2lbHyuDU+BtAAAAAElFTkSuQmCC"
  })
], -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

import { onMounted, ref, watch, onUnmounted } from 'vue';
import { isSameDay } from "date-fns";

import { useHolidayStore } from '@/store/common/holidayStore';

import HolidayService from "@/service/master/HolidayService";
import { IHolidayComponent } from "@/interface/component/master/i-holiday-component";


export default /*#__PURE__*/_defineComponent({
  __name: 'X1Calendar',
  setup(__props) {

const holidayStore = useHolidayStore();
const holidayService = ref(new HolidayService());

const x1Calendar = ref();
const right = ref(0);
const x1CalendarDiv = ref();

onMounted(() => {
    getHolidays();
    handleResize();
    window.addEventListener('resize', handleResize);
    x1CalendarDiv.value.removeAttribute('id');
});

onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
});

watch(() => x1Calendar.value, () => {
    handleResize();
}, { deep: true });

const handleResize = ()=>{
    right.value = 40;
}

const onKeydown = (event: any) => {
    if (event.code === 'Enter') {
        x1Calendar.value.overlayVisible = false;
    }
}

const cleanCalendarValue = () => {
    x1Calendar.value.updateModel(null);
}

const onIconClick = () => {
    x1Calendar.value.$el.children[0].focus();
}

const isHoliday = (date: any) => {

    let dateStr = date.year + '/' + (date.month + 1) + '/' + date.day;
    let holidayDate = new Date(dateStr);

    let index = holidayStore.holidays.findIndex((item) => {

        let d = new Date(item.holiday);

        return isSameDay(holidayDate, d);
    });

    return index >= 0;
}

const isSaturday = (date: any) => {
    let dateStr = date.year + '/' + (date.month + 1) + '/' + date.day;
    let holidayDate = new Date(dateStr);
    let nowDay = holidayDate.getDay();
    let weeks = ["日", "月", "火", "水", "木", "金", "土"];
    return weeks[nowDay];
}

const getHolidays = () => {
    if (holidayStore.holidays.length === 0) {
        holidayService.value.list()
            .then(data => {
                holidayStore.holidays = data as IHolidayComponent[];
            });
    }
}

return (_ctx: any,_cache: any) => {
  const _component_Calendar = _resolveComponent("Calendar")!

  return (_openBlock(), _createElementBlock("div", {
    class: "position-relative flex align-items-center",
    ref_key: "x1CalendarDiv",
    ref: x1CalendarDiv
  }, [
    _createVNode(_component_Calendar, _mergeProps(_ctx.$attrs, {
      ref_key: "x1Calendar",
      ref: x1Calendar,
      dateFormat: _ctx.$attrs.dateFormat ? _ctx.$attrs.dateFormat : 'yy/mm/dd',
      onKeypress: _withKeys(onKeydown, ["enter"]),
      style: {"width":"100%"},
      inputStyle: "border: 0px;border-radius: 0px;border-bottom: 1px solid #939090;font-size: 16px;font-family: Inter;font-weight: bold;color: #000000;background: transparent;"
    }), {
      date: _withCtx((slotProps) => [
        (isHoliday(slotProps.date) || isSaturday(slotProps.date) === '日')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("strong", null, _toDisplayString(slotProps.date.day), 1)
            ]))
          : _createCommentVNode("", true),
        (isSaturday(slotProps.date) === '土' && !isHoliday(slotProps.date))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("strong", null, _toDisplayString(slotProps.date.day), 1)
            ]))
          : _createCommentVNode("", true),
        (!isHoliday(slotProps.date) && !isSaturday(slotProps.date))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(slotProps.date.day), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16, ["dateFormat", "onKeypress"]),
    _withDirectives(_createElementVNode("span", {
      class: "pi pi-times position-absolute",
      style: _normalizeStyle('right:'+right.value+'px;'),
      onClick: cleanCalendarValue
    }, null, 4), [
      [_vShow, _ctx.$attrs.modelValue && !_ctx.$attrs.disabled && _ctx.$attrs.showX1Clear]
    ]),
    (_openBlock(), _createElementBlock("svg", {
      class: "position-absolute",
      style: _normalizeStyle([_ctx.$attrs.disabled?'opacity: 0.6':'', {"right":"0","cursor":"pointer"}]),
      width: "31",
      height: "56",
      viewBox: "0 0 31 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      onClick: onIconClick
    }, _hoisted_5, 4))
  ], 512))
}
}

})